import {
  selectAllSalesTeams,
  useGetSalesTeamListOnMount,
} from '@user/store/salesTeam'

import {
  selectAllSalesFunnels,
  useGetAllFunnelStagesOnMount,
  useGetSalesFunnelListOnMount,
  useSelectFunnelStagesByType,
} from '@user/store/salesFunnel'
import { useSelector } from 'react-redux'
import { useFormikContext } from 'formik'
import { LeadAssignmentRuleFormModel } from '../typings'

export function useData() {
  const {
    values: { salesFunnelId },
  } = useFormikContext<LeadAssignmentRuleFormModel>()
  const teamStatus = useGetSalesTeamListOnMount()

  const funnelStatus = useGetSalesFunnelListOnMount()
  const stagesStatus = useGetAllFunnelStagesOnMount()

  const initialLoading =
    funnelStatus === 'pending' ||
    teamStatus === 'pending' ||
    stagesStatus == 'pending'

  const failed = funnelStatus === 'fail' || teamStatus === 'fail'

  const success = funnelStatus === 'success' && teamStatus === 'success'

  const salesFunnels = useSelector(selectAllSalesFunnels)
  const stages = useSelectFunnelStagesByType(+salesFunnelId, 'Lead')

  const allSalesTeams = useSelector(selectAllSalesTeams)
  const salesTeams = allSalesTeams

  return {
    initialLoading,
    failed,
    success,
    salesFunnels,
    salesTeams,
    stages,
  }
}
